export default __webpack_public_path__ + "static/media/icon-ham.732d5e04.svg";